
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class HyperlinkContact extends Vue {
    @Prop({ type: String, required: true }) value!: string;
    @Prop({ type: Boolean, required: true }) showHyperlinks!: boolean;
    @Prop({ type: String, default: "tel" }) type?: "tel" | "email";
    @Prop({ type: String, required: true }) dataCy?: string;

    private get href(): string {
        if (!this.value) {
			return "";
		}

        const prefixes = {
            tel: "tel:",
            email: "mailto:"
        };

        return `${prefixes[this.type]}${this.value}`;
    }

    private get dataCyTag(): string {
        return this.dataCy || "";
    }
}
